/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */

import PubNub from 'pubnub';
import { CONFIG } from '@/constants/config';
import Bugsnag, { startBugsnag } from '@/utils/bugsnag';
import { isProductionClient, isStagingClient } from '@/utils/helpers';
import { bugsnagOnError, CustomError } from '@/utils/pubnub/bugsnagOnError';

export const notifyBugsnagError = (error: unknown, pubnub?: PubNub) => {
  if (CONFIG.bugsnagApiKey && pubnub) {
    if (!Bugsnag.isStarted()) {
      startBugsnag();
    }

    const { isProductionHref } = isProductionClient();
    const { isStagingHref } = isStagingClient();
    // @ts-ignore
    const category = error?.status?.category?.toString?.();

    const finalError = {
      ...(error as object),
      name: category ? `PubNub_${category}` : (error as Error).name,
    };

    const customError =
      finalError instanceof Error
        ? finalError
        : new CustomError(
            // @ts-ignore
            finalError?.status?.message ||
              // @ts-ignore
              finalError?.status?.category?.toString?.(),
            // @ts-ignore
            finalError?.status?.type,
            // @ts-ignore
            finalError?.status
          );

    if (isProductionHref || isStagingHref) {
      Bugsnag.notify(customError, event => {
        bugsnagOnError(event, customError);
      });
    }
  }
};
